/**
 * Goldman Sachs dark theme colors.
 */

const colors = {
  background: {
    default: "#0d1b2a",   // GS deep navy page background
    dark: "#08111a",      // GS darkest panel
  },

  text: {
    main: "#e8edf2",      // light on dark
    focus: "#ffffff",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#1a1a1a",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#c8a96e",      // GS gold accent on dark
    focus: "#d4bc88",
  },

  secondary: {
    main: "#8c98a8",
    focus: "#8c98a8",
  },

  info: {
    main: "#6ea8d4",      // muted blue on dark
    focus: "#89badf",
  },

  success: {
    main: "#4aad72",
    focus: "#4aad72",
  },

  warning: {
    main: "#d4a030",
    focus: "#d4a030",
  },

  error: {
    main: "#d95555",
    focus: "#d95555",
  },

  light: {
    main: "#1e2d3d",
    focus: "#243548",
  },

  dark: {
    main: "#c8d4e0",      // light text in dark context
    focus: "#e8edf2",
  },

  grey: {
    100: "#1e2d3d",
    200: "#243548",
    300: "#2c3f54",
    400: "#3d5266",
    500: "#5a6e80",
    600: "#8c98a8",
    700: "#b8c4d0",
    800: "#d8e2ea",
    900: "#e8edf2",
  },

  gradients: {
    primary: {
      main: "#c8a96e",
      state: "#d4bc88",
    },

    secondary: {
      main: "#5a6e80",
      state: "#8c98a8",
    },

    info: {
      main: "#6ea8d4",
      state: "#89badf",
    },

    success: {
      main: "#4aad72",
      state: "#5bc080",
    },

    warning: {
      main: "#d4a030",
      state: "#e0b040",
    },

    error: {
      main: "#d95555",
      state: "#e06060",
    },

    light: {
      main: "#2c3f54",
      state: "#3d5266",
    },

    dark: {
      main: "#c8d4e0",
      state: "#e8edf2",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#c8a96e",
      state: "#d4bc88",
      border: "#3d5266",
    },

    secondary: {
      main: "#8c98a8",
      state: "#b8c4d0",
      border: "#2c3f54",
    },

    info: {
      main: "#6ea8d4",
      state: "#89badf",
      border: "#2c3f54",
    },

    success: {
      main: "#4aad72",
      state: "#5bc080",
      border: "#1e3d2a",
    },

    warning: {
      main: "#d4a030",
      state: "#e0b040",
      border: "#3d2e10",
    },

    error: {
      main: "#d95555",
      state: "#e06060",
      border: "#3d1a1a",
    },

    light: {
      main: "#2c3f54",
      state: "#3d5266",
      border: "#1e2d3d",
    },

    dark: {
      main: "#c8d4e0",
      state: "#e8edf2",
      border: "#3d5266",
    },
  },

  badgeColors: {
    primary: {
      background: "#1e2d3d",
      text: "#c8a96e",
    },

    secondary: {
      background: "#1e2d3d",
      text: "#8c98a8",
    },

    info: {
      background: "#1e2d3d",
      text: "#6ea8d4",
    },

    success: {
      background: "#1a3028",
      text: "#4aad72",
    },

    warning: {
      background: "#2a2010",
      text: "#d4a030",
    },

    error: {
      background: "#2a1010",
      text: "#d95555",
    },

    light: {
      background: "#1e2d3d",
      text: "#8c98a8",
    },

    dark: {
      background: "#0d1b2a",
      text: "#c8d4e0",
    },
  },

  inputColors: {
    borderColor: { main: "#2c3f54", focus: "#6ea8d4" },
    error: "#d95555",
    success: "#4aad72",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
